// The API's slug rules: lowercase letters and numbers in groups separated by single dashes, at most 100 characters.
const SLUG_MAX_LENGTH = 100;

// A slug made from a title: lowercased, spaces turned into dashes, and anything else that isn't a letter or number dropped. Example: "Spin And Watch" -> "spin-and-watch"
export const toSlug = (title: string): string =>
  title
    .normalize('NFD') // Splits "é" into "e" and an accent mark, so only the accent is dropped.
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .slice(0, SLUG_MAX_LENGTH)
    .replace(/^-|-$/g, '');
